"use client";

import { Card, CardContent, Divider, Stack, TableCell, TableRow } from "@mui/material";
import { Dispatch, ReactNode, SetStateAction } from "react";
import SmoothDropdownButton from "../buttons/SmoothDropdownButton";

export type Props = {
  tableCells: ReactNode;
  cardContent?: ReactNode;
  actions?: ReactNode;
  dropdownContent?: ReactNode;
  cardSx?: object;
  tableRowSx?: object;
  mobile?: boolean;
  open?: boolean;
  setOpen?: Dispatch<SetStateAction<boolean>>;
  cardBottomContent?: ReactNode;
};

export default function ResponsiveTableRow({
  tableCells,
  cardContent,
  actions,
  dropdownContent,
  cardSx = {},
  tableRowSx = {},
  mobile = false,
  open,
  setOpen,
  cardBottomContent
}: Props) {
  if (mobile) {
    return (
      <Card
        variant="outlined"
        sx={{
          position: "relative",
          ...cardSx
        }}
      >
        <CardContent sx={{ pb: dropdownContent ? "0px !important" : "16px !important" }}>
          <Stack
            sx={{
              gap: 1
            }}
          >
            {cardContent}
            {(actions || dropdownContent) && <>{<Divider />}</>}
            <Stack
              direction={"row"}
              sx={{
                justifyContent: "space-between"
              }}
            >
              {dropdownContent && <SmoothDropdownButton open={open} onClick={() => setOpen(!open)} />}
              {cardBottomContent && <>{cardBottomContent}</>}
              {actions && <>{actions}</>}
            </Stack>
            {dropdownContent && <>{dropdownContent}</>}
          </Stack>
        </CardContent>
      </Card>
    );
  }

  return (
    <>
      <TableRow sx={{ ...tableRowSx }}>
        {dropdownContent && (
          <TableCell width={"10%"}>
            <SmoothDropdownButton open={open} onClick={() => setOpen((v) => !v)} />
          </TableCell>
        )}
        {tableCells}
        <TableCell>{actions}</TableCell>
      </TableRow>
      {dropdownContent && <>{dropdownContent}</>}
    </>
  );
}
